import clsx from 'clsx'
import { Button, CategorySelector, Dropdown, Icon, Popover } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import styles from 'components/MultipleSelect/multiple-select.module.scss'
// import ActionButtons from 'components/Filters/ActionButtons'

const MultipleSelect = ({
  buttonProps = { size: 'm', disabled: false },
  placeholder = '',
  name,
  value = [],
  values = [],
  onChange = () => {},
  onReset = null,
  buttonClass = '',
  listTitle = '',
  dropSelection = '',
  apply = '',
  minValues = 0,
}) => {
  const { bindTrigger, bindPopover, usePopupState } = Popover.usePopover()

  const popoverState = usePopupState({
    variant: 'popover',
    id: 'multiple-selector-' + name,
  })
  const [checked, setChecked] = useState(value)

  const [stateValues, setStateValues] = useState([])

  const [selected, setSelected] = useState([])

  useEffect(() => setSelected(value), [value])

  useEffect(() => {
    popoverState.isOpen && setChecked(value)
  }, [popoverState.isOpen, value])

  const handleSelect = useCallback(
    (newSelection) => {
      setSelected(newSelection)
      onChange(newSelection)
      popoverState.close()
    },
    [setSelected, onChange],
  )

  const handleReset = useCallback(() => {
    onReset && onReset()
    popoverState.close()
  }, [onReset])

  const handleChange = useCallback(
    (event) => {
      if (event.target.checked) {
        setChecked((state) => [...state, event.target.value])
      } else {
        setChecked((state) =>
          state.filter((value) => value !== event.target.value),
        )
      }
    },
    [setChecked],
  )

  useEffect(() => {
    setStateValues(
      values.map((props) => ({
        ...props,
        disabled: checked.length === minValues && checked.includes(props.value),
      })),
    )
  }, [values, setStateValues, checked])

  return (
    <div className={styles['multiple-select']}>
      <Button
        {...bindTrigger(popoverState)}
        noWrap
        className={clsx(styles['multiple-select__button'], buttonClass, {
          [styles['multiple-select__button_opened']]: !!popoverState.isOpen,
        })}
        startIcon={<Icon name={'union'} />}
        grey
        variant={'ghost'}
        {...buttonProps}
      >
        {placeholder} (
        {value.filter((val) => stateValues.find((v) => v.value === val))
          ?.length || 0}
        {'/'}
        {stateValues.length})
      </Button>
      <Popover
        bodyClassName={styles['multiple-select__popover-inner']}
        {...bindPopover(popoverState)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 2,
          horizontal: 'left',
        }}
        disablePortal={true}
        hideBackdrop={true}
        breakpoints={{
          0: {
            variant: 'bottomSheet',
            hasBackdrop: true,
            label: listTitle,
            showLabel: true,
          },
          391: {
            variant: 'popover',
            hasBackdrop: false,
            label: listTitle,
            showLabel: true,
          },
        }}
      >
        <Dropdown className={styles['dropdown']}>
          <CategorySelector
            className={styles['dropdown__scroll']}
            placeholder={placeholder}
            groups={stateValues.map(({ value, label, disabled = false }) => ({
              id: value,
              label,
              disabled,
            }))}
            values={selected}
            loading={false}
            onChange={handleChange}
            onSelect={handleSelect}
            onReset={handleReset}
            i18n={{
              dropSelection,
              apply,
            }}
          />
          {/*<ActionButtons
            className={styles['dropdown__action-button']}
            dropFilter={() => {
              onReset && onReset()
              popoverState.close()
            }}
            applyValue={() => {
              onChange(selected)
              popoverState.close()
            }}
            showActionButtons={true}
          />*/}
        </Dropdown>
      </Popover>
    </div>
  )
}

export default MultipleSelect

MultipleSelect.defaultProps = {
  placeholder: '',
  name: '',
  value: [],
  values: [],
  onChange: () => {},
  onReset: null,
  buttonClass: '',
  listTitle: '',
  dropSelection: '',
  apply: '',
}

MultipleSelect.propTypes = {
  buttonProps: PropTypes.object,
  noLabel: PropTypes.bool,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.array,
  values: PropTypes.array,
  onChange: PropTypes.func,
  onReset: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  buttonClass: PropTypes.string,
  listTitle: PropTypes.string,
  dropSelection: PropTypes.string,
  apply: PropTypes.string,
  minValues: PropTypes.number,
}
